import { Flex, Text, Badge, Spacer } from '@chakra-ui/react'
import { FC } from 'react'

import useReabTypeVeichule from '@hook/parametrization/use-reab-typeveichule'

import ReabTypeVeichuleCreate from './ModalCreate'
import ParametrizationReabTypeOFVeichuletModalDelete from './ModalDelete'

const SelectedTableBarReabTypeVeichule: FC = () => {
  const { selected } = useReabTypeVeichule()

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
    >
      <Flex alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          ml="1"
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selected !== 0 ? 1 : 0}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />

      {selected !== 0 ? <ParametrizationReabTypeOFVeichuletModalDelete /> : []}
      <ReabTypeVeichuleCreate />
    </Flex>
  )
}

export default SelectedTableBarReabTypeVeichule
